<div style="display: flex; align-items: center;justify-content: end;margin: 20px 25px;">
    <img mat-dialog-close="" src="icons/close-kb.svg" width="20px" alt="">
</div>
<mat-dialog-content>
    <cx-page-slot position="Section2B"></cx-page-slot>
    
    <div class="accept-btn-outer text-right" style="float: inline-end;"><button class="btn btn-blue btn-block"
            (click)="service.openWebShop = true" mat-dialog-close>
            {{'common.register_accept_message'|cxTranslate}}</button>
    </div>
</mat-dialog-content>